module.exports = __webpack_public_path__ + "da2760655e4c28f80d7166653c4ffbad.png";